import { ITariffs } from '~/src/entities/tariff-lines';

interface ITariffData {
    tariffName: string | null,
    salePackageId: number | null,
    price: number,
}

// @TODO Убрать вывод цены и проверку на тариф Mega, после доработок бэка
// Задача бекенд https://ticket.ertelecom.ru/browse/WEB-37909
// Задача фронт https://ticket.ertelecom.ru/browse/WEB-37910
export const getIdentifyDataFromFirstTariff = (tariffs: ITariffs | undefined, isVillage: boolean): ITariffData => {
    if (tariffs) {
        const { bundles, mono } = tariffs;

        const firstBundle = Object.values(bundles)
            .filter(bundle => (
                bundle.salePackage2in1.promo_price_final !== null ||
                bundle.salePackage2in1.price_final !== null
            ))
            .filter(item => item.salePackage2in1.is_cottage === Number(isVillage))
            .sort((a, b) => a.speed_int - b.speed_int)[0];

        if (firstBundle) {
            if (isVillage) {
                const parseString = firstBundle.tariff_name.toLowerCase();

                if (parseString.includes('mega') || parseString.includes('мега')) {
                    return {
                        tariffName: firstBundle.tariff_name,
                        salePackageId: firstBundle.sale_package_id,
                        price: firstBundle.price2in1,
                    };
                }
            }

            return {
                tariffName: firstBundle.tariff_name,
                salePackageId: firstBundle.sale_package_id,
                price: firstBundle.salePackage2in1.promo_price_final ?? firstBundle.salePackage2in1.price_final,
            };
        }

        const firstMono = Object.values(mono)
            .filter(mono => (
                mono.promo_price_final !== null ||
                mono.price_final !== null
            ))
            .filter(item => item.is_cottage === Number(isVillage))
            .sort((a, b) => a.speed - b.speed)[0];

        if (firstMono) {
            return {
                tariffName: firstMono.tariff_name,
                salePackageId: firstMono.sale_package_id,
                price: firstMono.promo_price_final ?? firstMono.price_final,
            };
        }
    }

    return {
        tariffName: null,
        salePackageId: null,
        price: 0,
    };
};
